import { SeoLandingTemplate } from "@/components/seo/seo-landing-template";
import {
	AI_TEAMMATES_MARKETING_EXTERNAL_LINKS,
	AI_TEAMMATES_MARKETING_FAQ_ITEMS,
	AI_TEAMMATES_MARKETING_H1,
	AI_TEAMMATES_MARKETING_INTEGRATIONS,
	AI_TEAMMATES_MARKETING_INTERNAL_LINKS,
	AI_TEAMMATES_MARKETING_INTRO_PARAGRAPHS,
	AI_TEAMMATES_MARKETING_OUTLINE,
	AI_TEAMMATES_MARKETING_SECTIONS,
} from "@/constants/seo/ai-teammates-marketing-content";
import { AI_TEAMMATES_MARKETING_LANDING_UI } from "@/constants/seo/seo-landing-ui";

export function AiTeammatesMarketingPage() {
	return (
		<SeoLandingTemplate
			ui={AI_TEAMMATES_MARKETING_LANDING_UI}
			h1={AI_TEAMMATES_MARKETING_H1}
			introParagraphs={AI_TEAMMATES_MARKETING_INTRO_PARAGRAPHS}
			outline={AI_TEAMMATES_MARKETING_OUTLINE}
			sections={AI_TEAMMATES_MARKETING_SECTIONS}
			internalLinks={AI_TEAMMATES_MARKETING_INTERNAL_LINKS}
			externalLinks={AI_TEAMMATES_MARKETING_EXTERNAL_LINKS}
			faqItems={AI_TEAMMATES_MARKETING_FAQ_ITEMS}
			spotlight={{
				title: "Current marketing integration coverage",
				description:
					"Use this list to sequence rollout by confirmed tool coverage and business impact.",
				items: AI_TEAMMATES_MARKETING_INTEGRATIONS,
			}}
		/>
	);
}
